class SelectHandler {

    constructor(elm) {
        this.elm = elm;
        this.bindEvents();
    }

    bindEvents() {
        this.elm.on('change', () => {
            this.elm.parent().find('.js-select-placeholder').html(this.elm.find('option:selected').html());
        });
    }

}

export default SelectHandler;